package org.ssoft.common.ui.wheel

import androidx.compose.foundation.Canvas
import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.geometry.CornerRadius
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.geometry.Size
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.ImageBitmap
import androidx.compose.ui.graphics.drawscope.clipRect
import androidx.compose.ui.graphics.drawscope.scale
import androidx.compose.ui.graphics.drawscope.translate
import androidx.compose.ui.graphics.painter.Painter
import androidx.compose.ui.layout.ContentScale
import apps.App


@Composable
internal fun WheelStartupScreen(
    config: App.Wheel,
    bgImage: ImageBitmap?,
    qr: Painter,
    modifier: Modifier,
) {
    WheelStartupScreen(
        modifier = modifier,
        bgImage = bgImage,
        bgColor = Color(config.content.theme.backgroundColor),
        showQr = config.content.qr.visible,
        qrX = config.content.qr.x.toFloat() / 100F,
        qrY = config.content.qr.y.toFloat() / 100F,
        qrScale = config.content.qr.scale.toFloat() / 100F,
        qrPadding = config.content.qr.padding.toFloat() / 100F,
        qr = qr
    )
}

@Composable
internal fun WheelStartupScreen(
    modifier: Modifier,
    bgColor: Color,
    bgImage: ImageBitmap?,
    showQr: Boolean,
    qrX: Float,
    qrY: Float,
    qrScale: Float,
    qrPadding: Float,
    qr: Painter
) {
    Box(
        modifier.background(bgColor)
    ) {
        bgImage?.also {
            Image(
                bitmap = it,
                contentDescription = null,
                modifier = Modifier.fillMaxSize(),
                contentScale = ContentScale.FillBounds,
            )
        }

        if (showQr) {
            Canvas(Modifier.fillMaxSize()) {
                val qrSize = ((qrScale) * minOf(
                    size.width,
                    size.height
                ))
                val padding = qrSize * (qrPadding / 2F)

                clipRect {
                    translate(
                        ((size.width * (qrX)) - (qrSize / 2F)),
                        ((size.height * (qrY)) - (qrSize / 2F))
                    ) {
                        drawRoundRect(
                            color = Color.White,
                            size = Size(qrSize, qrSize),
                            cornerRadius = CornerRadius(padding)
                        )
                        translate(padding, padding) {
                            with(qr) {
                                val ratio = (qrSize - (padding * 2F)) / intrinsicSize.width
                                scale(ratio, Offset.Zero) {
                                    draw(intrinsicSize)
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
